import { Component } from "@angular/core";
import { TranslatePipe, provideTranslationScope } from "@app/shared/i18n/translation-scope";
import { scope } from "@app/manual/i18n/scope";

@Component({
    selector: "api-usage-manual",
    templateUrl: "./api-usage-manual.component.html",
    styleUrls: ["../api-spec/api-spec.scss", "./api-usage-manual.component.scss"],
    imports: [TranslatePipe],
    viewProviders: [provideTranslationScope(scope)],
})
export class ApiUsageManualComponent {
    apiUrl: string;

    constructor() {
        this.apiUrl = window.location.origin + "/api";
    }
}
